import { Button, Table } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { Elevator } from "../Interfaces/Elevator";
import InspectionReportDialog from "../Dialogs/InspectionReportDialog";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

interface InspectionReportsListingProps {
	buildingId: string;
}

export interface InspectionReport {
	inspection_reports_id: string;
	buildings_id: string;
	date_entered: Date;
	file_name: string;
	elevator: string;
	elevators_id: string;
	description: string;
}
export default function InspectionReportsListing(props: InspectionReportsListingProps) {
	const [inspections, setInspections] = React.useState([] as Array<InspectionReport>);
	const [inspection, setInspection] = React.useState<InspectionReport>({} as InspectionReport);
	const [dialog, setDialog] = React.useState(false);
	const [elevators, setElevators] = React.useState<Array<Elevator>>([]);

	React.useEffect(() => {
		getData();
		getElevators();
	}, [props.buildingId]);

	const getElevators = () => {
		fetch("Building/GetElevators", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setElevators(x));
	};

	const getData = () => {
		fetch("Inspection/GetInspections", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(props.buildingId),
		})
			.then((x) => x.json())
			.then((x) => setInspections(x as Array<InspectionReport>));
	};

	const openInspection = (row: InspectionReport) => {
		var url = document.location.origin + "/Inspection/" + row.inspection_reports_id;
		window.open(url, "_blank");
	};

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			{/* {dialog && (
				<ContactsDialog
					buildingsId={props.buildingId}
					contactsId={cId}
					close={() => {
						getData();
						setDialog(false);
					}}
				/>
			)} */}
			<InspectionReportDialog
				buildingId={props.buildingId}
				open={dialog}
				inspectionReport={inspection}
				close={() => {
					setDialog(false);
					getData();
				}}
				elevators={elevators}
			/>
			<Button
				sx={{ mt: 1 }}
				onClick={() => {
					setInspection({} as InspectionReport);
					setDialog(true);
				}}>
				Add Report
			</Button>
			<Table stripe="even" hoverRow={true} sx={{ cursor: "pointer" }}>
				<thead>
					<tr>
						<th>Inspection</th>
						<th>Date</th>
						<th>Elevator</th>
						<th>Edit</th>
					</tr>
				</thead>
				<tbody>
					{inspections.map((x) => {
						return (
							<tr
								style={{ cursor: "pointer" }}
								onClick={() => {
									openInspection(x);
								}}>
								<td>{x.description}</td>
								<td>{Util.Formatter(x.date_entered, "D")}</td>
								<td>{x.elevator}</td>
								<td>
									<Button
										onClick={() => {
											setInspection(x);
											setDialog(true);
										}}>
										Edit
									</Button>
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</LocalizationProvider>
	);
}
